// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1hKXu","content":"styles_content__3IkWS","checkbox":"styles_checkbox__1lb9b","checkboxLabel":"styles_checkboxLabel__25UZi"};